import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, useNavigate, NavLink } from 'react-router-dom';



import { FaRegClock } from 'react-icons/fa';
import { FcBusinessman, FcManager, FcPortraitMode, FcAutomotive, FcInternal, FcShipped, FcDonate, FcKindle } from "react-icons/fc";


import { DataContext } from '../init/getData';

import LatestMembership from './latestMembership.js/latestMembership';




function LatestMembershipTransactionsTab(props) {

  const { settingData, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('latestMembership');

  useEffect(() => {

    navigate('/latestMembershipTab/latestMembership');

  }, []);


  return (
    <div className="card" style={{ paddingTop: '0px', userSelect: 'none' }}>

      <div>


        <NavLink to="latestMembership" onClick={() => setActiveTab('latestMembership')}>
          <div className={`${activeTab === 'latestMembership' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <FaRegClock color='rgb(255, 128, 0)' size={30} />
            <span className="tab-text">Latest Memberships</span>
          </div>
        </NavLink>

       

      </div>


      <Routes>

  

       
        <Route path='LatestMembership' element={<LatestMembership />} />



      </Routes>

    </div>
  );
}

export default LatestMembershipTransactionsTab;
